import { DATA_TYPE_CODE } from '~/web-frontend-core/api/const/base';
import { BaseSocketConnector } from '~/web-frontend-core/api/connector/BaseSocketConnector';
export class BetsCartFeaturesListener extends BaseSocketConnector {
    constructor() {
        super(...arguments);
        this.dataTypeCode = DATA_TYPE_CODE.BET_CART_FEATURES;
        this.isConnectionSelfClosable = true;
    }
    getOutcomeData(cfg) {
        // @ts-ignore
        return cfg.currency;
    }
}



// WEBPACK FOOTER //
// ./src/web-frontend-core/api/connector/cart/BetCartFeatures.js